import {Component, Input, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, NgZone, input, output, computed,} from '@angular/core';
import { TableColumn, HistoryTableRow } from './table.interface';
import { CommonModule } from '@angular/common';
import { HourRangePipe } from 'libs/shared/pipes/hour-range.pipe';
import { InfiniteScrollCustomEvent, IonInfiniteScroll, IonInfiniteScrollContent, IonContent, IonRefresherContent, IonRefresher, RefresherCustomEvent } from "@ionic/angular/standalone";

@Component({
  selector: 'lib-table-history',
  standalone: true,
  imports: [IonRefresher, IonRefresherContent, IonContent, IonInfiniteScrollContent, IonInfiniteScroll, CommonModule, HourRangePipe],
  templateUrl: './table-history.component.html'
})
export class TableHistory<T extends HistoryTableRow> implements OnInit, AfterViewInit, OnDestroy {
  @Input() columns: TableColumn<T>[] = [];
  @Input() data: T[] = [];
  format = input<'date-time' | 'time'>('time');
  loading = input<boolean>(false);
  disableInfiniteScroll = input(false);
  infiniteScroll = output<InfiniteScrollCustomEvent>();
  manualRefresh = output<RefresherCustomEvent>();

 
  headerTopPx = 44;        
  dayRowHeightPx = 32;

  @ViewChild('headRowEl', { static: false }) headRowEl!: ElementRef<HTMLElement>;
  private ro?: ResizeObserver;
  
  datePipeFormat = computed(() => {
    switch(this.format()){
      case 'date-time': return "dd-MM-yyyy HH:mm"
      case 'time': return "HH:mm"
    }
  })

  constructor(private zone: NgZone) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.updateHeaderTop();

    // Observa cambios de altura (cuando un title pasa a 2 líneas, resize de ventana, etc.)
    this.zone.runOutsideAngular(() => {
      this.ro = new ResizeObserver(() => {
        this.zone.run(() => this.updateHeaderTop());
      });

      if (this.headRowEl?.nativeElement) {
        this.ro.observe(this.headRowEl.nativeElement);
      }
    });
  }

  ngOnDestroy(): void {
    this.ro?.disconnect();
  }

  private updateHeaderTop(): void {
    const el = this.headRowEl?.nativeElement;
    if (!el) return;
    this.headerTopPx = Math.ceil(el.getBoundingClientRect().height);
  }
  
  infiniteScrollHandler(e: InfiniteScrollCustomEvent){
    this.infiniteScroll.emit(e);
  }
  
  refreshHandler(e: RefresherCustomEvent) {
    this.manualRefresh.emit(e);
  }

}
